import "./Commutator.scss";
import _ from "lodash";
import { SCOPES } from "constants/constants";
import { Scopes } from "utils/helper";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "api/user/UserProvider";

const Commutator = ({ id, currentTab, changeTab, ...rest }) => {
  const { userScopeList } = useUserContext();
  const [tabs, setTabs] = useState([SCOPES.PERSO, SCOPES.MACRO]);
  const intl = useIntl();

  const navigate = useNavigate();

  const verifyScope = ({ pathScope }) => {
    if (!_.includes(Scopes, pathScope)) {
      navigate("perso/not-found");
      return;
    }
    if (!_.includes(userScopeList, pathScope)) {
      navigate("perso/scope-not-found");
      return;
    }
  };

  useEffect(() => {
    if (_.isEmpty(userScopeList)) return;
    const path = window.location.href;
    const pathScope = _.chain(path).split("/").compact().nth(2).value();
    verifyScope({ pathScope });
    setTabs(userScopeList);
  }, [userScopeList]);

  return (
    <div id={id} className={rest.className}>
      <div className={`commutator size-${_.size(tabs)} `}>
        {tabs.map((tab, i) => (
          <input
            key={`input-${i}`}
            id={`commutator-${tab}`}
            label={intl.formatMessage({
              id: tab,
              defaultMessage: tab,
            })}
            type="radio"
            value={tab}
            checked={currentTab === tab}
            onChange={() => changeTab(tab)}
          />
        ))}
      </div>
    </div>
  );
};

export default Commutator;
